import types from './mutationTypes';
import setValue from '../../../utility/setValue';

export default {
  [types.CLEAR_NOTIFICATION](state) {
    state.notification = {
      type: '',
      value: '',
      status: '',
    };
  },
  [types.SET_NOTIFICATION](state, payload) {
    setValue(state.notification, 'value', payload.value);
    setValue(state.notification, 'status', payload.status || 'negative');

    if (payload.type) {
      setValue(state.notification, 'type', payload.type);
    }
  },
  [types.SET_CALLBACK](state, callback) {
    state.callback = callback;
  },
  [types.SET_TERMINAL_NOTIFICATION](state, payload) {
    setValue(state.terminalNotification, 'message', payload.message);
    setValue(state.terminalNotification, 'type', payload.type || 'info');
  },
  [types.CLEAR_TERMINAL_NOTIFICATION](state) {
    state.terminalNotification = {
      type: '',
      message: '',
    };
  },
};
